import request from '@/axios/index.js'
const uri = "/";
export function loginApi(data) {
    return request.axios({
        url: uri+'login',
        data: data
    })
}

export function logoutApi(data) {
    return request.axios({
        url: uri+'logout',
        data: data,
        loading:true
    })
}

export function selectTenant(data) {
    return request.axios({
        url: uri+'selectTenant',
        data: data
    })
}
export function getHeader(data) {
    return request.axios({
        url: uri+'header',
        data: data
    })
}





// WEBPACK FOOTER //
// ./src/api/login.js